import { useMutation, useQueryClient } from "@tanstack/react-query";
import { orbitLOnboardingDetailKeys } from "Api/Queries/Merchants/useOrbitLOnboardingDetailQuery";
import { orbitLOnboardingListKeys } from "Api/Queries/Merchants/useOrbitLOnboardingListQuery";
import { postMerchantsPublicIDOrbitLResubmitToComgate } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Parameters = {
  merchantPublicID: string;
};

type Props = {
  onSuccess?: () => void;
  onError?: () => void;
};

export const useResubmitOrbitLToComgateMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      ({ merchantPublicID }: Parameters) =>
        postMerchantsPublicIDOrbitLResubmitToComgate(merchantPublicID),
    ),
    onSuccess: (_data, { merchantPublicID }: Parameters) => {
      queryClient.invalidateQueries({
        queryKey: orbitLOnboardingListKeys.all,
      });
      queryClient.invalidateQueries({
        queryKey:
          orbitLOnboardingDetailKeys.byMerchantPublicId(merchantPublicID),
      });
      onSuccess?.();
    },
    onError,
  });
};
